import axios from "axios";
import Config from "config";

class SarcopeniaRepository {
  API_URL = {
    predict: `${process.env.REACT_APP_SLICE_BACK_URL}/api/image-data/`,
  };

  CancelToken = axios.CancelToken;
  cancelAxios = null;

  constructor(attr) {
    Object.assign(this, attr);
  }

  cancelRequestMeasureSarcopenia() {
    if (this.cancelAxios !== null) {
      this.cancelAxios();
      return true;
    }
    return false;
  }

  async requestMeasureSarcopenia(
    pixelData,
    mask,
    editmode,
    mask_status,
    width,
    height,
    pixelSpacingX,
    pixelSpacingY,
    sliceThickness,
    token
  ) {
    const queryAPI = this.API_URL["predict"];

    const payload = {
      image: pixelData,
      mask: mask,
      editmode: editmode,
      mask_status: mask_status,
      width,
      height,
      pixelSpacingX,
      pixelSpacingY,
      sliceThickness,
      token,
    };

    try {
      const response = await axios.post(queryAPI, payload, {
        cancelToken: new this.CancelToken((c) => {
          this.cancelAxios = c;
        }),
      });

      this.cancelAxios = null;
      return { data: response.data, status: response.status };

    } catch (error) {
      this.cancelAxios = null;

      if (error.response) {
        // 응답 상태코드와 데이터를 명확히 전달
        return { data: error.response.data, status: error.response.status };
      } else {
        return { data: { error: "서버 연결 오류" }, status: 500 };
      }
    }
  }
}

export default new SarcopeniaRepository();
